console.log('recommendations sdasd');

// Parsing the URL parameters and data and storing them in global variable "params"
var params = window.location.search
  .substr(1)
  .split('&')
  .reduce(function (q, query) {
    var chunks = query.split('=');
    var key = chunks[0];
    var value = chunks[1];
    return ((q[key] = value), q);
  }, {});

// The following code block is to show personalized messages based on the answers provided by quiz takers -- THIS IS AN EXAMPLE, PLEASE CUSTOMIZE THIS FOR YOUR QUIZ
if (params['tea_type'] == 'black_tea') {
  // Please change the param name and answer value as per your quiz
  document.getElementById('param_message').innerHTML =
    'We have just the right black tea recommendations for you';
} else if (params['tea_type'] == 'silver_tea') {
  // // Please change the param name and answer value as per your quiz
  document.getElementById('param_message').innerHTML =
    'We have just the right silver tea recommendations for you';
}

// If you would like to customize messages on the result page based on
//	more than one answer provided, then you may add operators to the code
//	provided above. For Example:
// if (params['tea_type'] == "black_tea" && params['caffeine'] == "no")
//	{  document.getElementById("param_message").innerHTML = "We have
//	just the right black tea recommendations with no caffeine for you";
//custom message is displayed if the quiz taker selects black tea
// AND caffeine
// if (params['tea_type'] == "black_tea" || params['tea_type'] == "silve
//	r_tea")
//	{  document.getElementById("param_message").innerHTML = "We have
//  just the right black tea and silver tea recommendations for you";
//custom message is displayed if the quiz taker selects black tea
// OR silver tea

// Storing product recommendations in another global variable
var product_handles = (params['products'] || '').split(',');

// Calling Shopify API to retrieve the products data
Promise.all(
  product_handles.map(function (product) {
    return new Promise(function (resolve, reject) {
      fetch('/products/' + product + '.json')
        .then(function (result) {
          // Making sure that the product actually exists
          if (result.status !== 404) {
            return result.json();
          } else {
            return { product: null };
          }
        })
        .then(function (data) {
          resolve(data.product);
        })
        .catch(reject);
    });
  })
).then(function (products) {
  // Filtering out the products list if it had any removed products
  products = products.filter(function (product) {
    return !!product;
  });

  // The product grid template
  var product_template = function (product, index) {
    var firstVariant =
      product.variants && product.variants.length ? product.variants[0] : null;
    var excerpt = (product.body_html || '').replace(/<[^>]+>/g, '').trim();
    if (excerpt.length > 140) excerpt = excerpt.slice(0, 137) + '...';

    const tagsArray = product.tags.split(',');

    return `
        <div class="product swiper-slide" itemprop="itemListElement" itemscope itemtype="http://schema.org/Product" data-product-id="${product.id}">
            <div class="product_image">
              ${
                product.images.length
                  ? `<a href="/products/${product.handle}" itemprop="url"><img src="${product.images[0].src}" alt="${product.title}" /></a>`
                  : ''
              }
            </div>
            <div class="h-full">
            <product-form class="quick-buy-product-form info" data-section-id="quick-buy-${product.id}">
              <div class="info-text">
                <span class="title" itemprop="name">${product.title}</span>
                ${product.product_type ? `<div class="type">${product.product_type}</div>` : ''}
                
                  <div class="product__tags">
                    ${tagsArray.map((tag, index) => `
                      <span class="product__tag text-sm ${index === tagsArray.length-1 ? 'last' : ''}">
                        ${tag}
                      </span>
                      ${index < tagsArray.length-1 ? `
                        <span class="product__tag text-sm">
                          |
                        </span>
                      ` : ''}
                    `).join('')}
                  </div>

                ${excerpt ? `<div class="desc">${excerpt}</div>` : ''}

                <div class="variant-wrap">
                  <select class="variant-select" id="variant-${product.id}" aria-label="Variant">
                    ${product.variants
                      .map(function (v) {
                        return `
                          <option 
                            value="${v.id}" 
                            data-available="${v.available}"
                            data-sku="${v.sku || ''}"
                            ${v.id === (firstVariant && firstVariant.id) ? 'selected' : ''}>
                            ${v.public_title || v.title}
                          </option>`;
                      })
                      .join('')}
                  </select>
                </div>
              </div>

              
                <form method="post" action="/cart/add" id="product-form-template--${product.id}__main" accept-charset="UTF-8" class="form quick-buy-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="id" value="${firstVariant ? firstVariant.id : ''}" class="product-variant-id"><div class="product-form__buttons flex justify-center items-center flex-col gap-4"><button id="ProductSubmitButton-template--${product.id}__main" type="submit" name="add" class="btn-primary button--primary">
                            <span>הוסף לסל
                        </span>

                        <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                        </div>
                        </button>

                    </div><input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" value="${product.id}">
                </form>
            </product-form>
            </div>
        </div>`;
  };

  // Fill the resulted products grid in the #products element
  document.getElementById('products').innerHTML = products
    .map(product_template)
    .join('');

  setTimeout(() => {
    var productsSwiper = new Swiper('.products-swiper', {
      slidesPerView: 1.3,
      spaceBetween: 10,
      pagination: {
        el: '.main-recommendation .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.main-recommendation .swiper-button-next',
        prevEl: '.main-recommendation .swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
      },
    });
  }, 1000);

  // Wire up variant change + add-to-cart
  (function initRecommendationsInteractions() {
    var containers = document.querySelectorAll('#products .product');
    containers.forEach(function (el) {
      var select = el.querySelector('.variant-select');
      var form = el.querySelector('.quick-buy-form');
      var submitBtn = el.querySelector('button[type="submit"]');

      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          // update hidden id for form
          form.querySelector('input[name="id"]').value = opt.value;
        });
      }

      // Handle form submission with AJAX to prevent redirect
      if (form && submitBtn) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();

          if (submitBtn.disabled) return;

          // Show loading state
          submitBtn.classList.add('loading');
          submitBtn.disabled = true;

          // Get form data
          const variantId = form.querySelector('input[name="id"]').value;
          const quantity = 1; // Default quantity

          // Add to cart via fetch API
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
            }),
          })
            .then(response => response.json())
            .then(data => {
              // Hide loading state
              submitBtn.classList.remove('loading');
              submitBtn.disabled = false;

              // Show success message or update cart icon
              // You can customize this part based on your needs
              console.log('Product added to cart:', data);

              // Update header cart count immediately
              if (typeof window.updateHeaderCartCount === 'function') {
                window.updateHeaderCartCount(data);
              }

              // Optionally trigger cart update events if you have cart components
              if (typeof window.publish === 'function') {
                window.publish('cart:update', { cartData: data });
              }

              // Open sticky cart using the provided function
              if (typeof cartBarButtonAction === 'function') {
                cartBarButtonAction();
              } else {
                console.warn('cartBarButtonAction function not found');
              }
            })
            .catch(error => {
              console.error('Error adding to cart:', error);

              // Hide loading state
              submitBtn.classList.remove('loading');
              submitBtn.disabled = false;

              // Show error message if needed
              alert('Error adding product to cart. Please try again.');
            });
        });
      }
    });
  })();
});

// Add restart quiz functionality
document.addEventListener('DOMContentLoaded', function () {
  const restartBtn = document.getElementById('restart-quiz-btn');
  if (restartBtn) {
    restartBtn.addEventListener('click', function () {
      // Remove all localStorage entries containing "vqb" in the key
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var key = localStorage.key(i);
        if (key && key.toLowerCase().includes('vqb')) {
          localStorage.removeItem(key);
        }
      }
      // Redirect to the quiz page
      window.location.href = '/pages/quiz';
    });
  }
});
